import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Table, Container, Spinner, Alert } from 'react-bootstrap';
import { API_BASE_URL, CLOUDINARY_CLOUD_NAME } from '../../config/constants';
import ConfirmationModal from '../Modal';
import { auth } from '../login/FirebaseConfig';
import { Button } from 'react-bootstrap';

const TablaAbmRestoYBar = () => {
    const COLLECTION_RESTOYBAR_NAME = 'restoybar';
    const user = auth.currentUser;

    const [docIds, setDocIds] = useState([]); // Estado que almacena todas las categorias obtenidas por fetchDocumentos
    const [loading, setLoading] = useState(true);
    const [loadingVerProductosAsociados, setLoadingVerProductosAsociados] = useState(null);

    const [error, setError] = useState(null);
    const [docInfo, setDocInfo] = useState(null); // Estado que almacena todos los productos de una categoria
    const [categoriaActual, setCategoriaActual] = useState(''); // Indica cual es la categoria de la cual se estan mostrando sus productos

    const [productoToDelete, setProductoToDelete] = useState(null);
    const [loadingDeleteProducto, setLoadingDeleteProducto] = useState(null); // Estado que administra cual es el botton a cambiar por un spinner mientras se elimina el producto
    const [showModalProducto, setShowModalProducto] = useState(false);

    const [imageToDelete, setImageToDelete] = useState(null);
    const [buttonsToggle, setButtonsToggle] = useState(true); // Estado para habilitar y deshabilitar los botones si una operacion se esta llevando a cabo

    const [categoriaToDelete, setCategoriaToDelete] = useState(null);
    const [showModalCategoria, setShowModalCategoria] = useState(false);
    const [loadingDeleteCategoria, setLoadingDeleteCategoria] = useState(null); // Estado que administra cual es el botton a cambiar por un spinner mientras se elimina la categoria

    const [updateTablaCategoriasFlag, setUpdateTablaCategoriasFlag] = useState(false); // Si se elimina una categoria, el flag pasa a true y se vuelve a ejecutar el useEffect

    const [textoGastronomiaActual, setTextoGastronomiaActual] = useState("");
    const [newTextoGastronomia, setNewTextoGastronomia] = useState("");
    const [savingTexto, setSavingTexto] = useState(false);
    const [messageGastronomiaTexto, setMessageGastronomiaTexto] = useState("")


    const navigate = useNavigate();

    // Consulta los datos de las categorias en la API
    useEffect(() => {
        const fetchDocumentos = async () => {
            try {
                const idToken = await user.getIdToken();
                setUpdateTablaCategoriasFlag(false);
                const response = await axios.post(`${API_BASE_URL}/getDocumentos`, { collectionName: COLLECTION_RESTOYBAR_NAME },
                    {
                        headers: {
                            Authorization: `Bearer ${idToken}`,
                        },
                    }
                );

                setDocIds(response.data.doc_ids);
                setLoading(false);
            } catch (error) {
                setError('Error recuperando la información');
                setLoading(false);
            }
        };

        fetchDocumentos();
    }, [updateTablaCategoriasFlag]);

    useEffect(() => {
        const fetchTextoGastronomia = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/getTextoGastronomia`);
                if (response.data && response.data.texto) {
                    setTextoGastronomiaActual(response.data.texto);
                }
            } catch (err) {
                console.error("Error obteniendo el texto de gastronomia:", err);
            }
        };
        fetchTextoGastronomia();
    }, []);

    const handleVerProductosAsociados = async (docId) => {
        try {
            setLoadingVerProductosAsociados(docId);
            setButtonsToggle(false);
            const idToken = await user.getIdToken();
            const response = await axios.post(`${API_BASE_URL}/getInfoDocumento`, { docId, collectionName: COLLECTION_RESTOYBAR_NAME },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );
            setCategoriaActual(docId);
            setDocInfo(response.data.doc_info);
        } catch (error) {
            setError('Error recuperando la información de la categoría');
        } finally {
            setLoadingVerProductosAsociados(null);
            setButtonsToggle(true);
        }
    };

    const handleDeleteCategoria = async () => {
        if (!categoriaToDelete) return;
        try {
            setShowModalCategoria(false);
            setButtonsToggle(false);
            setLoadingDeleteCategoria(categoriaToDelete);

            const idToken = await user.getIdToken();
            // Obtengo Informacion de todos los productos asociados a la categoria
            const response = await axios.post(`${API_BASE_URL}/getInfoDocumento`, { docId: categoriaToDelete, collectionName: COLLECTION_RESTOYBAR_NAME },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );
            if (response.data.doc_info.productos) {
                const productosAEliminar = response.data.doc_info.productos;
                // Chequea si productos a eliminar no es un objeto vacio {}
                if (productosAEliminar && Object.keys(productosAEliminar).length === 0) {
                    console.log("No hay productos para eliminar.");
                }
                else {
                    // Itero sobre cada uno de los productos, elimino la imagen del hosting de imagenes y luego elimino la informacion del producto en firestore
                    for (const producto of productosAEliminar) {
                        try {
                            // Elimina imagen
                            await axios.delete(`${API_BASE_URL}/eliminarArchivo/${producto.imagePublicId}`, {
                                headers: { Authorization: `Bearer ${idToken}` },
                            });
                        } catch (err) {
                            console.error(`Error eliminando imagen ${producto.imagePublicId}:`, err);
                        }

                        // Elimina el producto
                        await axios.delete(`${API_BASE_URL}/eliminarProducto/${categoriaToDelete}/${producto.id}`, {
                            headers: {
                                Authorization: `Bearer ${idToken}`,
                            },
                        });
                    }
                }
            }
            // Elimina la categoria en firestore
            await axios.delete(`${API_BASE_URL}/eliminarDocumento/${COLLECTION_RESTOYBAR_NAME}/${categoriaToDelete}`, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                },
            });

            // Clear docInfo after category is deleted
            setDocInfo(null);
        } catch (error) {
            setError('Error recuperando la información de la categoría');
        } finally {
            setUpdateTablaCategoriasFlag(true);
            setCategoriaToDelete(null);
            setButtonsToggle(true);
            setLoadingDeleteCategoria(null);
        }
    }

    const handleDeleteProducto = async () => {
        if (!productoToDelete) return;
        setShowModalProducto(false);
        setButtonsToggle(false);
        setLoadingDeleteProducto(productoToDelete.id);

        try {
            const idToken = await user.getIdToken();
            // Primero elimina la imagen, si existe
            if (imageToDelete !== "") {
                await axios.delete(`${API_BASE_URL}/eliminarArchivo/${imageToDelete}`, {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                });
            }
            // Luego elimina el producto
            await axios.delete(`${API_BASE_URL}/eliminarProducto/${categoriaActual}/${productoToDelete.id}`, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                },
            });

            // Vuelve a obtener los productos asociados a la categoria actual
            handleVerProductosAsociados(categoriaActual);

            setProductoToDelete(null);
            setImageToDelete(null);
        } catch (err) {
            console.error('Error eliminando Producto:', err);
        } finally {
            setButtonsToggle(true);
            setLoadingDeleteProducto(null);
        }

    }

    const handleShowModalProducto = (producto) => {
        setProductoToDelete(producto);
        if (!isImageUrlNull(producto.imagePublicId)) {
            setImageToDelete(producto.imagePublicId);
        }
        setShowModalProducto(true);
    };

    const handleToggleDestacado = async (producto, categoria) => {
        try {
            setButtonsToggle(false);
            const idToken = await user.getIdToken();
            const productoId = producto.id;
            const response = await axios.post(`${API_BASE_URL}/destacarProducto`, { productoId, categoria },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );
        } catch (err) {
            console.error('Error al destacar el producto:', err);
        } finally {
            handleVerProductosAsociados(categoria);
            setButtonsToggle(true);
        }
    };

    const handleCancelDeleteProducto = () => {
        setProductoToDelete(null);
        setImageToDelete(null);
        setShowModalProducto(false);
    };

    const handleShowModalCategoria = (categoria) => {
        setCategoriaToDelete(categoria);
        setShowModalCategoria(true);
    };

    const handleCancelDeleteCategoria = () => {
        setCategoriaToDelete(null);
        setShowModalCategoria(false);
    };

    const getImageUrl = (publicId) => {
        return `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/f_auto/${publicId}`;
    };

    const isImageUrlNull = (url) => { /* Determina si la url de la imagen de un item contiene una imagen valida, o tiene una url sin imagen */
        const regex = /\/image\/upload\/f_auto\/([^\/]+)?$/;
        const match = url.match(regex);
        return match ? !match[1] : false;
    }

    const handleSubmitGastronomiaTexto = async () => {
        const idToken = await user.getIdToken();
        setSavingTexto(true);
        try {
            await axios.post(`${API_BASE_URL}/setTextoGastronomia`,
                { texto: newTextoGastronomia },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );
            setMessageGastronomiaTexto("Texto actualizado con éxito.");
        } catch (error) {
            console.error("Error actualizando al texto:", error);
            setMessageGastronomiaTexto("Error al actualizar el texto.");
        } finally {
            setSavingTexto(false);
        }

    }

    if (loading) {
        return (
            <Container className="text-center mt-5 divfill">
                <Spinner animation="border" variant="dark" />
                <p>Cargando documentos...</p>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-5 divfill">
                <Alert variant="danger">{error}</Alert>
            </Container>
        );
    }

    return (
        <Container className="mt-5 divfill">
            <div className="my-4 p-3 border rounded bg-light">
                <h5>Editar Texto de Gastronomía</h5>
                <textarea
                    rows={4}
                    className="form-control mb-2"
                    placeholder={textoGastronomiaActual}
                    value={newTextoGastronomia}
                    onChange={(e) => setNewTextoGastronomia(e.target.value)}
                />
                <Button onClick={handleSubmitGastronomiaTexto} disabled={savingTexto}>
                    {savingTexto ? "Guardando..." : "Guardar Texto"}
                </Button>
                {messageGastronomiaTexto && <div className="mt-2">{messageGastronomiaTexto}</div>}
            </div>
            <h3>Categorías Resto y Bar</h3>
            <Table responsive bordered>
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {docIds.map((docId, index) => (
                        <tr key={docId}>
                            <td>{docId}</td>
                            <td>
                                <button
                                    className="btn btn-info me-2"
                                    onClick={() => handleVerProductosAsociados(docId)}
                                    disabled={!buttonsToggle}
                                >
                                    {loadingVerProductosAsociados === docId ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        "Ver Productos asociados"
                                    )}
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => handleShowModalCategoria(docId)}
                                    disabled={!buttonsToggle}
                                >
                                    {loadingDeleteCategoria === docId ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        "Eliminar"
                                    )}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {docInfo && (
                <div className="mt-5">
                    <h4>Productos Asociados a {docInfo.id}</h4>
                    <Table responsive bordered>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Descripción</th>
                                <th>Precio</th>
                                <th>Imágen</th>
                                <th>Destacado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(docInfo).map((key) => {
                                if (key === "productos") { // Solo toma informacion relevante al producto, no su metadata
                                    const productos = docInfo[key];
                                    return (
                                        <>
                                            {Object.keys(productos).length === 0 ? (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        No hay productos disponibles
                                                    </td>
                                                </tr>
                                            ) : (
                                                Object.keys(productos).map((key, index) => (
                                                    <tr key={`${key}-${index}`}>
                                                        <td>{productos[key].nombre}</td>
                                                        <td>{productos[key].descripcion}</td>
                                                        <td>{productos[key].precio}</td>
                                                        <td>
                                                            {!isImageUrlNull(getImageUrl(productos[key].imagePublicId)) ? (
                                                                <a href={getImageUrl(productos[key].imagePublicId)} target="_blank" rel="noopener noreferrer">
                                                                    <img
                                                                        src={getImageUrl(productos[key].imagePublicId)}
                                                                        alt={`Imagen ${productos[key].nombre}`}
                                                                        style={{ maxWidth: '75%' }}
                                                                    />
                                                                </a>
                                                            ) : (
                                                                <span>Sin imágen</span>
                                                            )}
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>
                                                            {productos[key].destacado ?
                                                                <button
                                                                    className="btn btn-link p-0 border-0"
                                                                    onClick={() => handleToggleDestacado(productos[key], docInfo.id)}
                                                                    disabled={!buttonsToggle}
                                                                >
                                                                    <i className="bi bi-star-fill fs-4 text-warning"></i>
                                                                </button> :
                                                                <button
                                                                    className="btn btn-link p-0 border-0"
                                                                    onClick={() => handleToggleDestacado(productos[key], docInfo.id)}
                                                                    disabled={!buttonsToggle}
                                                                >
                                                                    <i className="bi bi-star fs-4 text-warning"></i>
                                                                </button>
                                                            }
                                                        </td>

                                                        <td>
                                                            <button
                                                                className="btn btn-danger"
                                                                onClick={() => handleShowModalProducto(productos[key])}
                                                                disabled={!buttonsToggle}
                                                            >
                                                                {loadingDeleteProducto === productos[key].id ? (
                                                                    <span
                                                                        className="spinner-border spinner-border-sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    ></span>
                                                                ) : (
                                                                    "Eliminar"
                                                                )}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </>
                                    );
                                }
                            })}
                        </tbody>
                    </Table>
                </div>

            )}
            <button
                className="btn btn-success mt-2 mb-4"
                onClick={() => navigate('/crearCategoriaRestoyBar')}
            >
                Crear Nueva Categoría
            </button>
            <button
                className="btn btn-success mt-2 mb-4 mx-2"
                onClick={() => navigate('/crearProductoRestoyBar')}
            >
                Crear Nuevo Producto
            </button>
            <ConfirmationModal
                show={showModalProducto}
                onConfirm={handleDeleteProducto}
                onCancel={handleCancelDeleteProducto}
                message="¿Estás seguro de que deseas eliminar este producto? Esta acción es IRREVERSIBLE."
            />
            <ConfirmationModal
                show={showModalCategoria}
                onConfirm={handleDeleteCategoria}
                onCancel={handleCancelDeleteCategoria}
                message="¿Estás seguro de que deseas eliminar esta categoría? Esto eliminará a TODOS los productos asociados a la categoría. Esta acción es IRREVERSIBLE."
            />
        </Container>
    );
};

export default TablaAbmRestoYBar;
